import { Card as CardBase, Typography as TypographyBase } from '@chilecompra/react-kit/components'
import { Grid as GridBase, styled } from '@mui/material'

export const Root = styled('div')`
  width: 100%;
`

export const BoldText = styled('strong')``

export const Card = styled(CardBase)`
  &.MuiPaper-root {
    box-shadow: 0 4px 10px rgba(118, 138, 162, 0.2);
  }
`

export const ContainerImg = styled('div')`
  position: absolute;
  right: 0;
  top: 106px;
  z-index: 2;
`

export const CustomTypography = styled(TypographyBase)`
  &.MuiTypography-root {
    background: ${props => props.theme.palette.blue[20]};
  }
`

export const GridContainer = styled(GridBase)``

export const GridItem = styled(GridBase)``

export const Image = styled('img')`
  height: 100%;
  width: 100%;
`
